import editEmergencyFundGoalPlan from './edit-emergency-fund-goal-plan/types';
import editCustomGoalPlan from './edit-custom-goal-plan/types';
import editRetirementFundGoalPlan from './edit-retirement-fund-goal-plan/types';

export default {
  ...editEmergencyFundGoalPlan,
  ...editCustomGoalPlan,
  ...editRetirementFundGoalPlan,
};
